<template>
  <section class="section-wrapp">
    <Breadcrumbs
      v-if="station !== null"
      v-bind:parameters="breadcrumbsData"
    ></Breadcrumbs>
    <section class="section-graph">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <div class="device-graph-table style">
              <div class="device-table-wrapp">
                <div
                  v-if="devices !== null && values !== null"
                  class="device-table scroll-without-bg scroll-small-size"
                >
                  <table class="device-table">
                    <tr>
                      <th>Name</th>
                      <th v-for="(param, index) in params" :key="index">
                        <span>{{ param.title }}</span>
                      </th>
                      <th>Commands</th>
                    </tr>
                    <tr v-bind:key="device.id" v-for="device in devices">
                      <td>
                        <span>Name</span><b></b
                        ><i
                          @click="deviceView(device.id)"
                          style="cursor: pointer;text-decoration: underline;"
                          >{{ device.name }}</i
                        >
                      </td>
                      <td v-bind:key="param.key" v-for="param in params">
                        <span>{{ param.title }}</span
                        ><b></b><i>{{ values[device.id][param.key] }}</i>
                      </td>
                      <td>
                        <div class="command-buttons">
                          <div
                            v-for="command in device.commands"
                            class="command-btn"
                            @click="openModal(device, command)"
                          >
                            {{ command }}
                          </div>
                        </div>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div v-show="showModal" class="modal-overlay">
      <div class="modal-content">
        <div class="modal-header">
          <svg
            class="alert-icon"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M12 13V8m0 8h.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
            />
          </svg>
        </div>
        <div class="modal-body">
          Device: <b>{{ selectedDevice ? selectedDevice.name : "" }}</b
          ><br />
          Command:
          <b style="text-transform: uppercase">{{ selectedCommand }}</b>
        </div>
        <div class="modal-footer">
          <div class="modal-btn" @click="closeModal">Cancel</div>
          <div class="modal-btn confirm" @click="dispatchCommand">OK</div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Breadcrumbs from "../../components/Breadcrumbs";
import statistics from "../../api/statistics";
import station from "../../api/station";
import device from "../../api/device";

export default {
  name: "List",
  components: { Breadcrumbs },
  computed: {
    breadcrumbsData() {
      return [
        {
          url: "/station-view/" + this.station.id,
          title: this.station.title
        },
        {
          title: this.station.title + " (Inverter)",
          url: "#"
        }
      ];
    },
    station() {
      return this.$store.getters["station/station"];
    }
  },
  data() {
    return {
      devices: null,
      values: null,
      polling: null,
      params: null,
      showModal: false,
      selectedDevice: null,
      selectedCommand: null
    };
  },
  created() {
    let id = this.$route.params.id;

    this.$store.dispatch("station/findOne", id).then(() => {
      this.load(id);
    });
  },
  watch: {
    "$route.params.typeId": function() {
      this.load(this.$route.params.id);
    }
  },
  beforeDestroy() {
    clearInterval(this.polling);
  },
  methods: {
    closeModal() {
      this.showModal = false;
      this.selectedDevice = null;
      this.selectedCommand = null;
    },
    openModal(device, command) {
      this.selectedDevice = device;
      this.selectedCommand = command;
      this.showModal = true;
    },
    dispatchCommand() {
      device
        .dispatchCommand(this.selectedDevice.id, this.selectedCommand)
        .then(() => {
          // Handle successful command dispatch if needed

          this.closeModal();
        })
        .catch(err => {
          // Handle errors if command dispatch fails
          console.error("Failed to dispatch command:", err);
        });
      // Implement command dispatch logic here
    },
    deviceView(id) {
      this.$router.push({ name: "device-view", params: { id: id } });
    },
    load(id) {
      this.fetchData().then(r => {
        this.devices = r.devices;
        this.values = r.values;
        this.params = r.params;

        this.polling = setInterval(() => {
          station.lastData(id).then(r => {
            this.values = r.data;
          });
        }, 60 * 1000);
      });
    },
    async fetchData() {
      let id = this.$route.params.id;
      let typeId = Number(this.$route.params.typeId);
      let result = {};

      try {
        const r = await statistics.fetchDevices(id);
        result.devices = r.data[typeId];
      } catch (err) {
        throw new Error("Cant fetch devices");
      }

      try {
        const r = await device.types();
        const deviceType = r.data.find(deviceType => deviceType.id === typeId);
        result.params = deviceType.config.list.params;
      } catch (err) {
        throw new Error("Cant fetch params config");
      }

      try {
        const r = await station.lastData(id);
        result.values = r.data;
      } catch (e) {
        throw new Error("Cant fetch last data");
      }

      return result;
    }
  }
};
</script>

<style>
.command-buttons {
  display: flex;
  gap: 8px;
}

.command-btn {
  padding: 6px 12px;
  background-color: #02a8eb; /* Blue background for buttons */
  color: white; /* White text */
  border: none;
  border-radius: 4px;
  cursor: pointer;
  border: 1px solid #02a8eb;
  font-weight: 700;
  text-transform: uppercase;
}

.command-btn:hover {
  background-color: #0280b3;
  border-color: #0280b3;
}

.modal-overlay {
  position: fixed;
  display: flex;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: 10;
  background-color: rgb(0 0 0 / 70%); /* 50% opacity black */
}

.modal-content {
  margin: auto;
  padding: 12px;
  background-color: white; /* Dark background for the modal content */
  border-radius: 8px;
  text-align: center;
  min-width: 300px;
}

.modal-header {
  display: flex;
  justify-content: center;
  margin-bottom: 16px;
}

.modal-body {
  font-size: 16px;
  color: #242526; /* White text */
}

.modal-footer {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  gap: 10px;
}

.modal-btn {
  padding: 10px 20px;
  background-color: white; /* Blue background for buttons */
  color: #242526; /* White text */
  border: none;
  border-radius: 4px;
  cursor: pointer;
  width: 100%;
  border: 1px solid #87898a;
  font-weight: 700;
}

.modal-btn.confirm {
  background-color: #f36f37;
  color: white;
  border: 1px solid #f36f37;
}

.modal-btn.confirm:hover {
  background-color: #c25324;
}

.alert-icon {
  width: 32px;
  height: 32px;
  color: red;
}
</style>
